<div class="ai-chat-input-shell">
  <div
    class="ai-chat-input-box"
    [class.ai-chat-input-box--loading]="isLoading()">
    <div class="ai-chat-input-row">
      <textarea
        test-id="ai-chat-input-value-set"
        #textarea
        class="ai-chat-input"
        rows="2"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [ngModel]="value()"
        (ngModelChange)="value.set($event)"
        (keydown)="onKeydown($event)"></textarea>
    </div>
    <div class="ai-chat-input-action-row">
      <cor-ai-model-picker
        class="ai-chat-model-picker-compact"
        [(selected)]="selectedModel" />
      @if (isLoading()) {
        <button
          test-id="ai-chat-input-stop"
          type="button"
          class="ai-chat-send-circle"
          pTooltip="Stop"
          tooltipPosition="top"
          (click)="abortRequest.emit()">
          <i class="pi pi-stop tw:text-primary-contrast"></i>
        </button>
      } @else {
        <button
          test-id="ai-chat-input-send"
          type="button"
          class="ai-chat-send-circle"
          [disabled]="disabled() || !value().trim()"
          pTooltip="Send"
          tooltipPosition="top"
          (click)="onSendClick()">
          <i class="pi pi-send tw:text-primary-contrast"></i>
        </button>
      }
    </div>
  </div>
</div>
